import { render, staticRenderFns } from "./CaseInboxDrawer.vue?vue&type=template&id=7db6a65f&"
import script from "./CaseInboxDrawer.vue?vue&type=script&lang=js&"
export * from "./CaseInboxDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports